import LxcError from "~/core/models/LxcError.class";
import type { OperationModel } from "~/core/models/OperationModel.interface";
import type { CampaignInclusionPeriodsI } from "~/modules/campaign/components/CampaignOperationMgrFunnelStep3InclusionPeriods.vue";
import { CUSTOM_INPUT_PARAMETERS_NAMES } from "~/modules/campaign/models/CampaignOperationMgr.enum";
import { campaignInclusionPeriodCreateUpdateMapper } from "~/modules/campaign/utils/campaignInclusionPeriodCreateUpdateMapper";
import type { Firmware } from "~/modules/firmware/models/Firmware.interface";
import firmwareService from "~/modules/firmware/services/firmware.service";
import organizationService from "~/modules/organization/services/organization.service";

export async function getCustomInputParameters(
  organizationCode: number,
  operationModel: OperationModel,
  firmware?: Firmware,
  inclusionPeriods?: CampaignInclusionPeriodsI,
) {
  let customInputParameters: Record<string, unknown> = {};

  if (firmware) {
    const response = await firmwareService.getOrganizationFirmwareUrls(
      organizationCode,
      firmware.uuid,
      operationModel.uid,
    );
    if (LxcError.check(response)) {
      return response;
    } else {
      customInputParameters = { ...response };
    }
  }

  for (const customInputParameter of operationModel.customInputParameters) {
    switch (customInputParameter.name) {
      case CUSTOM_INPUT_PARAMETERS_NAMES.TARGET_VERSION:
        customInputParameters[CUSTOM_INPUT_PARAMETERS_NAMES.TARGET_VERSION] =
          firmware?.version;
        break;
      case CUSTOM_INPUT_PARAMETERS_NAMES.FIRMWARE_UID:
        customInputParameters[CUSTOM_INPUT_PARAMETERS_NAMES.FIRMWARE_UID] =
          firmware?.uuid;
        break;
      case CUSTOM_INPUT_PARAMETERS_NAMES.INCLUSION_PERIODS:
        if (inclusionPeriods) {
          const currentOrganization =
            await organizationService.getOrganization(organizationCode);
          customInputParameters[
            CUSTOM_INPUT_PARAMETERS_NAMES.INCLUSION_PERIODS
          ] = campaignInclusionPeriodCreateUpdateMapper(
            inclusionPeriods.periods,
            currentOrganization.timezone,
          );
        }
        break;
    }
  }

  return customInputParameters;
}
